import { formatDate } from '@silverfort-nodelibs/common/utils/common';
import { INCIDENT_TYPE, ROLES } from '@silverfort-nodelibs/common/utils/consts';
import { Dropdown } from '@silverfort/sf-components';
import { INCIDENT_STATUS_OPTIONS } from '../IncidentsTable/Filters/FilterOptions';
import { getRiskIndicatorByRiskRule, RISK_RULES } from '@silverfort-nodelibs/common/utils/insight';
import { bigNumberToText, isUserPermitted } from '../../../components/utils';
import { EntityAttribute } from '../../../components/EntityCard/EntityAttribute';

const getEnumGuiNameByApiName = (apiName: string) => {
    return Object.values(INCIDENT_TYPE).find((type) => type.apiName === apiName)?.guiName || 'N\\A';
};

const getStatusValue = (apiStatus: string) => {
    return (
        INCIDENT_STATUS_OPTIONS.find((option) => option.title.toUpperCase() === apiStatus)?.value ??
        INCIDENT_STATUS_OPTIONS[0].value
    );
};

const mitigationByIncidentType = {
    [INCIDENT_TYPE.BRUTE_FORCE.value]: RISK_RULES.USER_BRUTEFORCE,
    [INCIDENT_TYPE.LOG4SHELL.value]: RISK_RULES.LOG4SHELL
};

const IncidentDetails = ({ incidentData, userData, incidentTypeObj, onStatusChange }) => {
    const isEditor = isUserPermitted(userData.user, 'risk', ROLES.EDITOR.value);
    const riskIndicator = getRiskIndicatorByRiskRule(mitigationByIncidentType[incidentTypeObj?.value]);

    return (
        <div className="h-[90%] grid grid-flow-col auto-cols-fr grid-rows-[100%]">
            <div>
                <EntityAttribute label="Incident ID" value={incidentData.id.substring(incidentData.id.length - 12)} />
                <EntityAttribute label="Incident Type" value={getEnumGuiNameByApiName(incidentData.kind)} />
                <EntityAttribute label="Authentications #" value={bigNumberToText(incidentData.auth_count)} />
            </div>
            <div>
                <EntityAttribute label="Start Time" value={formatDate(incidentData.start_time, navigator, false)} />
                <EntityAttribute
                    label="Last Activity"
                    value={formatDate(incidentData.last_log_timestamp, navigator, false)}
                />
                <EntityAttribute
                    label="Status"
                    valueChild={
                        <Dropdown
                            className={`w-[120px] [&&]:bg-[#212a30] text-sf-white border-b border-sf-gray-500 hover:bg-sf-gray-600`}
                            items={INCIDENT_STATUS_OPTIONS}
                            selectedItems={getStatusValue(incidentData.status)}
                            variant="trigger"
                            disabled={!isEditor}
                            onChange={(value) => {
                                incidentData.status !== value && onStatusChange([incidentData.id], value);
                            }}
                        />
                    }
                />
            </div>
            {riskIndicator?.mitigation && (
                <div className="h-full">
                    <div className="max-h-full overflow-y-auto border-l border-sf-gray-500 px-2">
                        <div className="text-sf-gray-500 text-14">Mitigation:</div>
                        <div className="text-sf-white text-ellipsis text-13 whitespace-normal">
                            {riskIndicator?.mitigation ?? ''}
                        </div>
                        {riskIndicator?.reference && (
                            <a href={riskIndicator.reference.link} target="_blank" rel="noreferrer" className='text-sf-primary'>
                                {`${riskIndicator.reference.desc} `}
                            </a>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};
export default IncidentDetails;
